// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23d9a","col":"styles_col__2YKVb"};